import styled from "styled-components";
import MarcaForm from "../../../sharable/MarcaForm.jsx";
import { MenuDescription, MenuTitle } from "../Toolbar.jsx";
const Container = styled.div`
  height: calc(100vh - 8.4rem);
  overflow-y: auto;
  overflow-x: hidden;
`;

//COMPONENT VERIFIED
export default function BrandMenuView({ props }) {
  return (
    <Container>
      <MenuDescription>
        Adicione suas informações de contato e endereço. Caso queira omitir
        alguma informação apenas deixe em branco!
      </MenuDescription>
      <MenuTitle>sua marca</MenuTitle>
      <MarcaForm flex="column" />
    </Container>
  );
}
